import React from "react";
import "../styles/About.css";

function About() {
  return (
    <div className="about-page">
      <h1>About Us</h1>
      <h2>Our Philosophy</h2>
      <p>
        At MKAI Karate (Meishin Karate Association of Integrity), we believe
        that Karate is more than a martial art—it is a way of life guided by
        integrity, truth, and honesty. Our mission is to empower students to
        embrace discipline, maintain physical and mental fitness, and develop
        strong character that reflects the principles of Meishin both inside and
        outside the dojo. By blending traditional techniques with modern
        training methods, MKAI Karate shapes confident, respectful, and
        resilient individuals who live by the values of honesty, integrity, and
        perseverance, carrying the true spirit of Karate into every aspect of
        their lives.
      </p>

      <img src="/about/6.JPG" alt="About Karate" className="about-img" />
      <h2> Our Journey: From 2011 to MKAI Karate</h2>
      <p>
        Meishin Karate Association of Integrity (MKAI) was officially founded in
        2025 by Sensei K. Manikandan (4th Dan, Karate India Organisation –
        National Judge), who serves as the President and Founder of MKAI Karate.
        However, the journey began much earlier. Sensei K. Manikandan started
        conducting karate classes in 2011 in Kolathur, training students with
        dedication and passion. What began as a small group of committed
        learners gradually evolved into a strong and disciplined karate
        community. <br></br>
        <br></br>Our dojo began in Kolathur in 2011, where each class focused on
        building skill, confidence, and self-discipline. Through continuous
        dedication and a commitment to quality training, MKAI Karate has
        steadily grown and now serves students across multiple branches
        throughout Tamil Nadu. With a vision to promote Karate as a way of life,
        MKAI is committed to nurturing discipline, confidence, respect, and
        strong character in practitioners of all ages. As the guiding force
        behind MKAI Karate, Sensei Manikandan brings years of experience in both
        traditional and competitive karate. He emphasizes technical excellence,
        mental strength, and leadership development, inspiring students to
        achieve their full potential both on and off the mat.
      </p>

      <img
        src="/about/2.JPG"
        alt="Sensei K. Manikandan"
        className="about-img"
      />

      <p>
        The success and growth of MKAI Karate are made possible by our dedicated
        team of Assistant Instructors, who play a vital role in training,
        mentoring, and guiding students. Each instructor brings specialized
        expertise and a commitment to nurturing the next generation of martial
        artists. Together, they ensure that students not only develop technical
        skills but also learn important life values such as respect,
        perseverance, focus, and confidence.
        {/* <h2>Our Assistant Instructors</h2> */}
        <br></br>
        <b>Our Team OF Assistant Instructors:</b>
        <br></br>
        1. Sempei Dr. C. Sandhiya
        <br />
        2. Sempei C. Arunkumar
        <br />
        3. Sempei B. Saravanakumar
        <br />
        4. Sempei R. VijayKrishna
        <br />
        5. Sempei B. Surya
        <br />
        6. Sempei V. Karthikeyan
      </p>
      <img
        src="/about/3.JPG"
        alt="Assistant Instructors"
        className="about-img"
      />

      <h2>Our Training Style</h2>
      <p>
        {/* We specialise in Seigokan Goju-Ryu Karate, a traditional Japanese style
        founded in 1945 by Seigo Tada Sensei and presently led by Grand Master
        Kyoshi Takeshi Fukuchi, 8th Dan. Known for its unique balance of hard
        and soft techniques, Seigokan Goju-Ryu emphasizes powerful strikes,
        close-range defence, breathing control, and mental discipline. Training
        is rooted in Kihon (basics), Kata (forms), and Kumite (sparring),
        ensuring the holistic development of both body and mind.
        <br />
        In addition to traditional training, TEAM SKAI_KOLATHUR also offers
        Sports Karate, Self-Defence, and Tournament Coaching, with our students
        consistently excelling at state and national-level competitions.
        <br />
        At SKAI_Kolathur, we believe Karate is more than just a martial art—it
        is a way of life that builds respect, resilience, and leadership. Our
        mission is to empower students of all ages to embrace discipline, stay
        healthy, and cultivate a strong character that extends beyond the dojo.
        With a blend of tradition and modern training methods, we continue to
        shape confident individuals who carry the true spirit of Karate into
        every aspect of their lives. */}
        MKAI Karate specializes in Goju-Ryu Karate, a traditional Japanese style
        that emphasizes a balanced approach, combining hard and soft techniques,
        proper breathing, and mental focus. This style develops strength,
        flexibility, precision, and resilience, ensuring students gain both
        physical skills and mental discipline.<br></br>
        <br></br>
        <b>Training at MKAI Karate focuses on:</b>
        <br></br>● Kihon (Basics): Strengthening foundational techniques{" "}
        <br></br>● Kata (Forms): Developing precision, coordination, and focus
        <br></br>● Kumite (Sparring): Practicing controlled and competitive
        fighting
        <br></br> Goju-Ryu Karate is designed not only to build powerful
        techniques but also to cultivate inner strength, mental clarity, and
        perseverance. Our training emphasizes the harmony of body and mind,
        teaching students to stay calm under pressure, react effectively, and
        carry confidence into daily life. At MKAI Karate, every session
        reinforces discipline, respect, and self-control, ensuring that students
        grow into well-rounded martial artists who embody the true spirit of
        Goju-Ryu. Whether for self-defense, fitness, or competitive achievement,
        our style provides a holistic foundation that benefits practitioners of
        all ages and levels.
      </p>

      <h2>Our Grading System</h2>
      <p>
        At<b> MKAI Karate</b>, students progress through a structured belt
        system designed to develop skill, discipline, and character. Grading
        ensures that every student strengthens their foundation inKihon
        (basics), Kata (forms), and Kumite (sparring) while embodying the core
        values of Karate:respect, perseverance, and self-control.
        <br></br>
        <b>Belt Levels and Kyu Grades</b>
        <br></br>● White Belt (10th Kyu) – Beginner level, introduction to
        fundamentals and discipline
        <br></br>● Yellow Belt (9th Kyu) – Developing basic techniques and focus
        <br></br>● Orange Belt (8th Kyu) – Enhancing coordination, timing, and
        basic Kata
        <br></br>● Green Belt (7th Kyu) – Strengthening techniques and sparring
        skills
        <br></br>● Blue Belt (6th Kyu) – Advanced techniques and Kata
        proficiency
        <br></br>● Purple Belt (5th Kyu) – Advanced techniques, controlled
        Kumite, and preparation for Brown belts
        <br></br>● Brown 4 → Brown 1 Belts (4th → 1st Kyu) – Higher-level Kata
        and advanced techniques, mastery of complex Kata, and developing
        mentoring abilities in preparation for Black Belt
        <br></br>● Black Belt (1st Dan and above) – Mastery of fundamentals,
        leadership, teaching, and mentoring
      </p>
      <img src="/about/5.JPG" alt="About Karate" className="about-img" />

      <p>
        Gradings are conducted under the supervision of Chief Examiner – Sensei
        K. Manikandan (4th Dan, KIO – National Judge) along with our Assistant
        Instructors. Evaluations focus on technical skill, attitude, discipline,
        and overall character, helping students grow in all aspects. This
        grading system is designed to challenge students at the right level,
        encourage steady improvement, and celebrate their achievements.
        Excellence in tournaments and demonstrations is also recognized,
        reinforcing the values of commitment, hard work, and integrity.
      </p>
    </div>
  );
}

export default About;
